import { CSSProperties } from 'react';
import BarcodeViewerPrimary from './BarcodeViewerPrimary';
import BarcodeViewerSecondary from './BarcodeViewerSecondary';

export interface BarcodeViewerProps {
  width?: number;
  height?: number;
  matrix?: number[];
  top?: number;
  left?: number;
  right?: number;
  text?: string;
  code?: string;
  textAlign?: CSSProperties['textAlign'];
  fontFamily?: CSSProperties['fontFamily'];
  fontWeight?: CSSProperties['fontWeight'];
  variant?: 'primary' | 'secondary';
  color?: [number, number, number];
}

function BarcodeViewer({ variant = 'primary', ...props }: BarcodeViewerProps) {
  switch (variant) {
    case 'primary':
      return <BarcodeViewerPrimary {...props} />;

    case 'secondary':
      return <BarcodeViewerSecondary {...props} />;
  }
}

export default BarcodeViewer;
